var _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossCurricular(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4384_30042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0007 3C16.8745 3 14.2486 3.16533 12.0841 3.64637C9.90068 4.13162 8.08592 4.96 6.68995 6.35597C5.29398 7.75193 4.4656 9.5667 3.98035 11.7501C3.49932 13.9146 3.33398 16.5405 3.33398 19.6667C3.33398 22.7928 3.49932 25.4187 3.98035 27.5832C4.4656 29.7667 5.29398 31.5813 6.68995 32.9773C8.08592 34.3733 9.90068 35.2017 12.0841 35.687C14.2486 36.168 16.8745 36.3333 20.0007 36.3333C23.1268 36.3333 25.7527 36.168 27.9172 35.687C30.1007 35.2017 31.9153 34.3733 33.3113 32.9773C34.7073 31.5813 35.5357 29.7667 36.021 27.5832C36.502 25.4187 36.6673 22.7928 36.6673 19.6667C36.6673 16.5405 36.502 13.9146 36.021 11.7501C35.5357 9.5667 34.7073 7.75193 33.3113 6.35597C31.9153 4.96 30.1007 4.13162 27.9172 3.64637C25.7527 3.16533 23.1268 3 20.0007 3Z",
    fill: "url(#paint0_linear_4384_30042)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4384_30042)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0007 4C16.8974 4 14.3581 4.1654 12.301 4.62255C10.2363 5.08142 8.61713 5.843 7.39706 7.06307C6.17699 8.28314 5.4154 9.90235 4.95654 11.9671C4.49939 14.0241 4.33398 16.5634 4.33398 19.6667C4.33398 22.7699 4.49939 25.3092 4.95653 27.3662L3.98035 27.5832C3.49932 25.4187 3.33398 22.7928 3.33398 19.6667C3.33398 16.5405 3.49932 13.9146 3.98035 11.7501C4.4656 9.5667 5.29398 7.75193 6.68995 6.35597C8.08592 4.96 9.90068 4.13162 12.0841 3.64637C14.2486 3.16533 16.8745 3 20.0007 3C23.1268 3 25.7527 3.16533 27.9172 3.64637L27.7002 4.62255C25.6432 4.1654 23.1039 4 20.0007 4ZM35.0448 11.9671C34.5859 9.90234 33.8243 8.28314 32.6042 7.06308C31.3841 5.843 29.765 5.08142 27.7002 4.62255L27.9172 3.64637C30.1007 4.13162 31.9153 4.96 33.3113 6.35597C34.7073 7.75193 35.5357 9.5667 36.021 11.7501C36.502 13.9146 36.6673 16.5405 36.6673 19.6667C36.6673 22.7928 36.502 25.4187 36.021 27.5832C35.5357 29.7667 34.7073 31.5813 33.3113 32.9773C31.9153 34.3733 30.1007 35.2017 27.9172 35.687C25.7527 36.168 23.1268 36.3333 20.0007 36.3333C16.8745 36.3333 14.2486 36.168 12.0841 35.687C9.90068 35.2017 8.08592 34.3733 6.68995 32.9773C5.29398 31.5813 4.4656 29.7667 3.98035 27.5832L4.95654 27.3662C5.4154 29.431 6.17698 31.0501 7.39707 32.2702C8.61713 33.4903 10.2363 34.2519 12.3011 34.7108C14.3581 35.1679 16.8974 35.3333 20.0007 35.3333C23.1039 35.3333 25.6432 35.1679 27.7002 34.7108C29.765 34.2519 31.3841 33.4903 32.6042 32.2702C33.8243 31.0501 34.5859 29.431 35.0448 27.3662C35.5019 25.3092 35.6673 22.7699 35.6673 19.6667C35.6673 16.5635 35.5019 14.0241 35.0448 11.9671Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4384_30042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2472 17.4375H16.7585C16.7131 17.1155 16.6203 16.8295 16.4801 16.5795C16.34 16.3258 16.16 16.1098 15.9403 15.9318C15.7206 15.7538 15.4669 15.6174 15.179 15.5227C14.8949 15.428 14.5862 15.3807 14.2528 15.3807C13.6506 15.3807 13.1259 15.5303 12.679 15.8295C12.232 16.125 11.8854 16.5568 11.6392 17.125C11.393 17.6894 11.2699 18.375 11.2699 19.1818C11.2699 20.0114 11.393 20.7083 11.6392 21.2727C11.8892 21.8371 12.2377 22.2633 12.6847 22.5511C13.1316 22.839 13.6487 22.983 14.2358 22.983C14.5653 22.983 14.8703 22.9394 15.1506 22.8523C15.4347 22.7652 15.6866 22.6383 15.9062 22.4716C16.1259 22.3011 16.3078 22.0947 16.4517 21.8523C16.5994 21.6098 16.7017 21.3333 16.7585 21.0227L19.2472 21.0341C19.1828 21.5682 19.0218 22.0833 18.7642 22.5795C18.5104 23.072 18.1676 23.5133 17.7358 23.9034C17.3078 24.2898 16.7964 24.5966 16.2017 24.8239C15.6108 25.0473 14.9422 25.1591 14.196 25.1591C13.1581 25.1591 12.2301 24.9242 11.4119 24.4545C10.5975 23.9848 9.9536 23.3049 9.48011 22.4148C9.01042 21.5246 8.77557 20.447 8.77557 19.1818C8.77557 17.9129 9.0142 16.8333 9.49148 15.9432C9.96875 15.053 10.6165 14.375 11.4347 13.9091C12.2528 13.4394 13.1733 13.2045 14.196 13.2045C14.8703 13.2045 15.4953 13.2992 16.071 13.4886C16.6506 13.678 17.1638 13.9545 17.6108 14.3182C18.0578 14.678 18.4214 15.1193 18.7017 15.642C18.9858 16.1648 19.1676 16.7633 19.2472 17.4375ZM31.2784 17.4375H28.7898C28.7443 17.1155 28.6515 16.8295 28.5114 16.5795C28.3712 16.3258 28.1913 16.1098 27.9716 15.9318C27.7519 15.7538 27.4981 15.6174 27.2102 15.5227C26.9261 15.428 26.6174 15.3807 26.2841 15.3807C25.6818 15.3807 25.1572 15.5303 24.7102 15.8295C24.2633 16.125 23.9167 16.5568 23.6705 17.125C23.4242 17.6894 23.3011 18.375 23.3011 19.1818C23.3011 20.0114 23.4242 20.7083 23.6705 21.2727C23.9205 21.8371 24.2689 22.2633 24.7159 22.5511C25.1629 22.839 25.6799 22.983 26.267 22.983C26.5966 22.983 26.9015 22.9394 27.1818 22.8523C27.4659 22.7652 27.7178 22.6383 27.9375 22.4716C28.1572 22.3011 28.339 22.0947 28.483 21.8523C28.6307 21.6098 28.733 21.3333 28.7898 21.0227L31.2784 21.0341C31.214 21.5682 31.053 22.0833 30.7955 22.5795C30.5417 23.072 30.1989 23.5133 29.767 23.9034C29.339 24.2898 28.8277 24.5966 28.233 24.8239C27.642 25.0473 26.9735 25.1591 26.2273 25.1591C25.1894 25.1591 24.2614 24.9242 23.4432 24.4545C22.6288 23.9848 21.9848 23.3049 21.5114 22.4148C21.0417 21.5246 20.8068 20.447 20.8068 19.1818C20.8068 17.9129 21.0455 16.8333 21.5227 15.9432C22 15.053 22.6477 14.375 23.4659 13.9091C24.2841 13.4394 25.2045 13.2045 26.2273 13.2045C26.9015 13.2045 27.5265 13.2992 28.1023 13.4886C28.6818 13.678 29.1951 13.9545 29.642 14.3182C30.089 14.678 30.4527 15.1193 30.733 15.642C31.017 16.1648 31.1989 16.7633 31.2784 17.4375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4384_30042",
    x: 1.33398,
    y: 1,
    width: 37.3333,
    height: 37.3334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4384_30042"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4384_30042",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4384_30042",
    x: 1.33398,
    y: 1,
    width: 37.3333,
    height: 37.3334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4384_30042"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4384_30042",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4384_30042",
    x: 6.34191,
    y: 13.2046,
    width: 27.3702,
    height: 16.8218,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.43366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.21683
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4384_30042"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4384_30042",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4384_30042",
    x1: 20.0007,
    y1: 3,
    x2: 20.0007,
    y2: 36.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EA6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585,
    stopColor: "#285959"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCurricular);
export default __webpack_public_path__ + "static/media/CrossCurricular.069d82c97c583db7b32981885e160e9f.svg";
export { ForwardRef as ReactComponent };